module.exports = __webpack_public_path__ + "static/forum_of_firms-844c416b56769b5e4634e8c2c96dda73.png";